export const formatMoney = (price:any) => {
    if (price) {
        return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
    return '0.00';
};